var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-item__row" }, [
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [
          _vm._v("Google Click ID"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.gclid)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [_vm._v("Source")]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.campaign_source)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [_vm._v("Name")]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.campaign_name)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [_vm._v("Medium")]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.campaign_medium)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [_vm._v("Content")]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.campaign_content)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [
          _vm._v("Sendgrid Stage"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.sendgrid_stage)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-item__field" }, [
      _c("div", { staticClass: "input-group input-group-booking-detail" }, [
        _c("span", { staticClass: "input-group-addon" }, [
          _vm._v("Existing User"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "form-control" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("nullable")(_vm.source.existing_user)) +
              "\n      "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }